const desc = `<p class="c2" dir="rtl">
  <span class="c1">נחמה פוחצ&#39;יבסקי ע"ה</span><span class="c0"> </span
  ><span class="c5 bold">הדואר</span
  ><span class="c1">  ט"ז תמוז תרצ"ד 1934 06 29</span>
</p>`;

export default desc;
